// extracted by css-extract-rspack-plugin
export default {"header":"gnRY1e","menus":"IK35bk","typeZoomControl":"UtrrQH","dragToMap":"T43b6U","watermark":"JezDSo"};